// src/components/ui/ThemeToggle/ThemeToggle.jsx
// ============================================================
// ПЕРЕКЛЮЧАТЕЛЬ ТЕМЫ (светлая / тёмная / как в системе).
//
// 🔑 ПОЧЕМУ ТРИ СОСТОЯНИЯ, А НЕ ДВА.
//    Кнопка «солнце/луна» необратимо отменяет системную настройку:
//    нажав её один раз, пользователь навсегда теряет следование за ОС.
//    Режим «система» возвращает это поведение и стоит по умолчанию.
//
// ⚠️ Иконки рисуются по `resolved` (что реально применено), а не по
//    `preference`. Иначе при режиме «система» в тёмной ОС показывалась
//    бы иконка солнца — пользователь видел бы тёмный экран и солнце.
// ============================================================

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Sun, Moon, Monitor } from 'lucide-react';
import {
  setTheme,
  selectThemePreference,
  selectResolvedTheme,
} from '../../../store/themeSlice.js';

export const ThemeToggle = ({ className = '', size = 20 }) => {
  const dispatch = useDispatch();
  const preference = useSelector(selectThemePreference);
  const resolved = useSelector(selectResolvedTheme);

  // Порядок обхода намеренный: система → светлая → тёмная → система.
  const next = {
    system: 'light',
    light: 'dark',
    dark: 'system',
  }[preference] || 'system';

  const labels = {
    system: 'Как в системе',
    light: 'Светлая тема',
    dark: 'Тёмная тема',
  };

  const Icon = preference === 'system' ? Monitor : resolved === 'dark' ? Moon : Sun;

  return (
    <button
      type="button"
      onClick={() => dispatch(setTheme(next))}
      title={`${labels[preference]}. Переключить на «${labels[next]}»`}
      aria-label={`Тема оформления: ${labels[preference]}. Переключить на «${labels[next]}»`}
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        // ⚠️ Цвета — ТОЛЬКО через токены. Литералы здесь сломали бы
        //    тёмную тему ровно в том элементе, который её переключает.
        color: 'rgb(var(--c-text))',
        background: 'transparent',
        border: '1px solid transparent',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgb(var(--c-accent-soft))';
        e.currentTarget.style.borderColor = 'rgb(var(--c-border))';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.borderColor = 'transparent';
      }}
    >
      <Icon size={size} strokeWidth={1.8} />
    </button>
  );
};

export default ThemeToggle;
